import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import TermsConditionModal from '../../Shared/TermsConditionModal';
import Input from '../../Shared/Input';
import Button from '../../Shared/Button';
import '../../../css/ProfileManagement/CompanyInfo.css';
import save from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-left.svg';
import savedark from '../../../Assets/ProfileManagement/Assets-Desktop/userprofile.svg';
import edit from '../../../Assets/ProfileManagement/Assets-Desktop/edit.svg';
import editlight from '../../../Assets/ProfileManagement/Assets-Desktop/editenable.svg';
import check from '../../../Assets/ProfileManagement/Assets-Desktop/checkbox.svg';
import checked from '../../../Assets/ProfileManagement/Assets-Desktop/checkbox-checked.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import SubmitModal from '../../Shared/SubmitModal';
import AddProfileModal from '../../Shared/GenericModalError';
import UploadFile from '../../Shared/UploadFile';
import uploadEnable from '../../../Assets/ProfileManagement/Assets-Desktop/upload.svg';
import uploadDisable from '../../../Assets/ProfileManagement/Assets-Desktop/uploadDisable.svg';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
// for redux
import { useSelector } from 'react-redux';
import { workFlowBaseURL, baseURL } from '../../../Services/config/apiGateway';
import {
    START_PROFILE_ENDPOINT,
    GET_ALL_PROFILE_ENDPOINT,
    GET_ALL_PROFILE_DETAILS_ENDPOINT,
    COMPLETE_PROFILE_FORM_ENDPOINT,
    PROFILE_ENDPOINT,
    REWORK_PROFILE,
} from '../../../Services/config/apiEndPoints';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { AES, enc } from 'crypto-js';
import { toast } from "react-toastify";
toast.configure()
let buttonSubmitValue = false;
let tempTaskId;
let bankDetailsOfRespondent;
const CompanyInfo = () => {
    const pathObj = useParams();
    const userProfileDataR = useSelector(state => JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8)));
    const [hasOpen, setHasOpen] = useState(false);
    const [hasOpenPending, setHasOpenPending] = useState(false);
    let history = useHistory();
    const [hasOpenterms, setHasOpenTerms] = useState(false);
    const [isCheckVAT, setisCheckVAT] = useState(false);
    const [postalAddressCheck, setpostalAddressCheck] = useState(false);
    const [companyName, setCompanyName] = useState();
    const [companyRegNum, setCompanyRegNum] = useState();
    const [filePathCIPC, setFilePathCIPC] = useState('');
    const [vatRegNum, setVATRegNum] = useState('');
    const [filePathVAT, setFilePathVAT] = useState('');
    const [fileNameCIPC, setFileNameCIPC] = useState('');
    const [fileNameVAT, setFileNameVAT] = useState('');
    const [addressL1, setAddressL1] = useState();
    const [addressL2, setAddressL2] = useState();
    const [city, setCity] = useState();
    const [province, setProvince] = useState();
    const [country, setCountry] = useState("South Africa (ZA)");
    const [postalCode, setPostalCode] = useState();
    const [postalAddressL1, setPostalAddressL1] = useState();
    const [postalAddressL2, setPostalAddressL2] = useState();
    const [postalCity, setPostalCity] = useState();
    const [postalProvince, setPostalProvince] = useState();
    const [postalCountry, setPostalCountry] = useState("South Africa (ZA)");
    const [postalPostalCode, setPostalPostalCode] = useState();
    const [clickEdit, setClickEdit] = useState(false);
    const [clickSave, setClickSave] = useState(false);
    const [clickContinue, setClickContinue] = useState(false);
    const [clickCheckbox, setClickCheckbox] = useState(false);
    let [companyNameError, setCompanyNameError] = useState();
    let [companyRegNumError, setCompanyRegNumError] = useState();
    let [vatRegNumError, setVATRegNumError] = useState();
    let [addressL1Error, setAddressL1Error] = useState();
    let [cityError, setCityError] = useState();
    let [provinceError, setProvinceError] = useState();
    let [countryError, setCountryError] = useState();
    let [postalCodeError, setPostalCodeError] = useState();
    let [postalAddressL1Error, setPostalAddressL1Error] = useState();
    let [postalCityError, setPostalCityError] = useState();
    let [postalProvinceError, setPostalProvinceError] = useState();
    let [postalCountryError, setPostalCountryError] = useState();
    let [postalPostalCodeError, setPostalPostalCodeError] = useState();
    let [fileUploadError, setFileUploadError] = useState();
    let [fileUpload1Error, setFileUpload1Error] = useState();
    // for loader and page disable
    const [pageDisable, setPageDisable] = useState(false);
    const [roleType, setRoleType] = useState('');
    const [roleName, setRoleName] = useState('');
    const [roleID, setRoleID] = useState('');
    const [profileTypeAndStatus, setProfileTypeAndStatus] = useState('');
    const [getTaskId, setGetTaskId] = useState('');
    //view profile phone=true and add profile phone= false;
    const profileApproved = ['Approved', 'approved', 'APPROVED'];
    const profilePending = ['Pending', 'pending', 'PENDING'];
    const profileIncomplete = ['Not Completed', 'Not completed', 'not completed', 'NOT COMPLETED'];
    const profileReject = ['Rejected', 'rejected', 'REJECTED'];
    const [uploadFileDisableCIPC, setUploadFileDisableCIPC] = useState(false);
    const [uploadFileDisableVAT, setUploadFileDisableVAT] = useState(false);
    const [phone, setPhone] = useState(true);
    // for remove require after upload file 
    const uploadFileFun = (uploadConfirm) => {
        setFileUploadError("");
        document.getElementById('uploadCIPC').style.borderColor = ColorCode.colorCode.black;
    }
    const uploadFileFunVAT = (uploadConfirm) => {
        setFileUpload1Error("");
        document.getElementById('uploadVAT').style.borderColor = ColorCode.colorCode.black;
    }
    // uploaded file path
    const setUploadLinkCIPC = (filePathURL) => {
        setFilePathCIPC(filePathURL);
        console.log('path--', filePathURL?.split('/')[11]?.split("'")[0]?.split('.')[1]);
        setFileNameCIPC(`CIPC_Statement.${filePathURL?.split('/')[11]?.split("'")[0]?.split('.')[1]}`)
        // for loader end
        setPageDisable(false);
        console.log("CIPC", filePathURL);
    }
    const setUploadLinkVAT = (filePathURL) => {
        setFilePathVAT(filePathURL);
        setFileNameVAT(`VAT_Certificate.${filePathURL?.split('/')[11]?.split("'")[0]?.split('.')[1]}`);
        setPageDisable(false);
        console.log("VAT", filePathURL);
    }
    const removeCIPCUploadedLink = () => {
        let path = "";
        setFileNameCIPC(path);
        setFilePathCIPC(path);
    }
    const removeVATUploadedLink = () => {
        let path = "";
        setFileNameVAT(path);
        setFilePathVAT(path);
    }
    // for start page loading when upload file   
    const setLoaderCIPC = (filePathURL) => {
        setPageDisable(filePathURL);
    }
    const setLoaderVAT = (filePathURL) => {
        setPageDisable(filePathURL);
    }
    const handleKeyDown = event => {
        if (event.key === " ") {
            event.preventDefault();
        }
    };
    const onClosetermsModal = () => {
        setHasOpenTerms(false);
        //this.setState({hasOpenterms: false});
    };
    useEffect(() => {
        const { roleId, roleTypeValue, roleNameValue, profileTypeAndStatusValue } = pathObj;
        setRoleType(roleTypeValue);
        setRoleName(roleNameValue);
        setRoleID(roleId);
        setProfileTypeAndStatus(profileTypeAndStatusValue);
        //--------------view profile for Requester and Respondent
        // call user task and check profile is present or not
        if (["Not Completed", 'Not completed', "not completed", "NOT COMPLETED", 'rejected', 'REJECTED', 'Rejected'].includes(profileTypeAndStatusValue) || profileTypeAndStatusValue === "add-profile") {
            viewProfileDataAndTaskId(roleTypeValue, profileTypeAndStatusValue);
        }
        else if (["Approved", "approved", "APPROVED"].includes(profileTypeAndStatusValue)) {
            setTaskIdForApproved(roleTypeValue, profileTypeAndStatusValue);
            viewPorfileDataOfApproved();
        } else if (['Pending', 'pending', 'PENDING'].includes(profileTypeAndStatusValue)) {
            viewPorfileDataOfPending(roleTypeValue);
        }
        let phoneCheck = true;
        // for view profile
        if (profileApproved.includes(profileTypeAndStatusValue) || profilePending.includes(profileTypeAndStatusValue) || profileIncomplete.includes(profileTypeAndStatusValue) || profileReject.includes(profileTypeAndStatusValue)) {
            // already phonecheck value true    
            setPhone(true);
        }
        if (profileTypeAndStatusValue === 'add-profile') {
            phoneCheck = false;
            setPhone(false);
        }
        // pending modal when user in pending state
        if (roleTypeValue === "Respondent" && profilePending.includes(profileTypeAndStatusValue) || profileApproved.includes(profileTypeAndStatusValue)) {
            setHasOpenPending(true);
        }
        if (phoneCheck) {
            setClickCheckbox(true);
            setClickContinue(true);
            if (roleTypeValue === "Requester") {
                if (profilePending.includes(profileTypeAndStatusValue) || profileApproved.includes(profileTypeAndStatusValue)) {
                    // open modal when status is pending.
                    setHasOpenPending(true);
                }
            }
        }
    }, []);
    const viewPorfileDataOfPending = (roleTypeValue) => {
        ApiCall(
            'GET',
            workFlowBaseURL + GET_ALL_PROFILE_DETAILS_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                // 'userId': 361

            },
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("I am 500")
                }
                else {
                    console.log('I am 200!');
                    data?.map((i, index) => (
                        data[index].taskData.profileUpdateRequest = JSON.parse(data[index].taskData.profileUpdateRequest)
                    ))
                    data?.sort((a, b) =>
                        b.taskData.profileUpdateRequest?.submitDate - a.taskData.profileUpdateRequest?.submitDate
                    )
                    data?.every((md, index) => {
                        if (roleTypeValue.includes(md.taskData.profileUpdateRequest.profileRole.roleType) && ['ReviewProfile', 'reviewProfile'].includes(md.taskName)) {
                            console.log('vp--', md, md.taskId);
                            //set data for view profile 
                            setCompanyRegNum(md.taskData.profileUpdateRequest?.companyDetails?.registrationNumber);
                            setCompanyName(md.taskData.profileUpdateRequest?.companyDetails?.companyName);
                            setVATRegNum(md.taskData.profileUpdateRequest?.companyDetails?.vatNumber);
                            if (md.taskData.profileUpdateRequest?.companyDetails?.vatRegisteredFlag === 'false') {
                                setisCheckVAT(true);
                                document.getElementById('uploadVAT').style.borderColor = ColorCode.colorCode.black;
                                //disable upload
                                document.getElementById('vatUpload').style.color = "#C4C4C4";
                                document.getElementById('vatUploadType').style.color = "#C4C4C4";
                                document.getElementById('vatUploadTypeName').style.color = "#C4C4C4";
                                document.getElementById('vatUploadSize').style.color = "#C4C4C4";
                                document.getElementById('vatUploadSizeName').style.color = "#C4C4C4";
                                document.getElementById('vatUploadIcon').src = uploadDisable;
                                document.getElementById('vatFile').style.display = 'none';
                            }
                            else {
                                setisCheckVAT(false);
                            }
                            setFileNameCIPC(md.taskData.profileUpdateRequest.companyDetails?.companyDocument?.documentName);
                            setFilePathCIPC(md.taskData.profileUpdateRequest.companyDetails?.companyDocument?.documentPicture);
                            setUploadFileDisableCIPC(md.taskData.profileUpdateRequest.companyDetails?.companyDocument?.documentName?.length > 0 ? true : false);
                            setFileNameVAT(md.taskData.profileUpdateRequest.companyDetails?.vatDocument?.documentName);
                            setFilePathVAT(md.taskData.profileUpdateRequest.companyDetails?.vatDocument?.documentPicture);
                            setUploadFileDisableVAT(md.taskData.profileUpdateRequest.companyDetails?.vatDocument?.documentName?.length > 0 ? true : false)
                            // physical address
                            setAddressL1(md.taskData.profileUpdateRequest.physicalAddress?.addressline1);
                            setAddressL2(md.taskData.profileUpdateRequest.physicalAddress?.addressline2);
                            setCity(md.taskData.profileUpdateRequest.physicalAddress?.city);
                            setProvince(md.taskData.profileUpdateRequest.physicalAddress?.province);
                            setCountry(md.taskData.profileUpdateRequest.physicalAddress?.countryName);
                            setPostalCode(md.taskData.profileUpdateRequest.physicalAddress?.postalCode);
                            // postal address
                            setPostalAddressL1(md.taskData.profileUpdateRequest.postalAddress?.addressline1);
                            setPostalAddressL2(md.taskData.profileUpdateRequest.postalAddress?.addressline2);
                            setPostalCity(md.taskData.profileUpdateRequest.postalAddress?.city);
                            setPostalProvince(md.taskData.profileUpdateRequest.postalAddress?.province);
                            setPostalCountry(md.taskData.profileUpdateRequest.postalAddress?.countryName);
                            setPostalPostalCode(md.taskData.profileUpdateRequest.postalAddress?.postalCode);
                            return false
                        }
                        return true
                    })
                }
            }
            else {
                console.log('something went wrong');
                return -1;
            }
        })
    }
    const viewPorfileDataOfApproved = () => {
        // for approved view profile
        ApiCall(
            'GET',
            baseURL + PROFILE_ENDPOINT + `?userName=${userProfileDataR?.userEmail}`,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    setCompanyRegNum(data.companyDetails?.registrationNumber);
                    setCompanyName(data.companyDetails?.companyName);
                    setVATRegNum(data.companyDetails?.vatNumber);
                    if (data.companyDetails?.vatRegisteredFlag === 'false') {
                        setisCheckVAT(true);
                        document.getElementById('uploadVAT').style.borderColor = ColorCode.colorCode.black;
                        document.getElementById('vatUpload').style.color = "#C4C4C4";
                        document.getElementById('vatUploadType').style.color = "#C4C4C4";
                        document.getElementById('vatUploadTypeName').style.color = "#C4C4C4";
                        document.getElementById('vatUploadSize').style.color = "#C4C4C4";
                        document.getElementById('vatUploadSizeName').style.color = "#C4C4C4";
                        document.getElementById('vatUploadIcon').src = uploadDisable;
                        document.getElementById('vatFile').style.display = 'none';
                    }
                    else {
                        setisCheckVAT(false);
                    }
                    setFileNameCIPC(data.companyDetails?.companyDocument?.documentName);
                    setFilePathCIPC(data.companyDetails?.companyDocument?.documentPicture);
                    setUploadFileDisableCIPC(data.companyDetails?.companyDocument?.documentName?.length > 0 ? true : false);
                    setFileNameVAT(data.companyDetails?.vatDocument?.documentName);
                    setFilePathVAT(data.companyDetails?.vatDocument?.documentPicture);
                    setUploadFileDisableVAT(data.companyDetails?.vatDocument?.documentName?.length > 0 ? true : false)
                    // physical address
                    setAddressL1(data.address[1]?.addressline1);
                    setAddressL2(data.address[1]?.addressline2);
                    setCity(data.address[1]?.city);
                    setProvince(data.address[1]?.province);
                    setCountry(data.address[1]?.countryName);
                    setPostalCode(data.address[1]?.postalCode);
                    // postal address
                    setPostalAddressL1(data.address[0]?.addressline1);
                    setPostalAddressL2(data.address[0]?.addressline2);
                    setPostalCity(data.address[0]?.city);
                    setPostalProvince(data.address[0]?.province);
                    setPostalCountry(data.address[0]?.countryName);
                    setPostalPostalCode(data.address[0]?.postalCode);
                }
            }
            else {
                console.log('something went wrong');
            }
        })
    }
    // find task id in case of approved profile 
    const setTaskIdForApproved = (roleTypeValue, viewProfileTypeAndStatus) => {
        ApiCall(
            'GET',
            workFlowBaseURL + GET_ALL_PROFILE_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            },
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("I am 500")
                }
                else {
                    console.log('I am 200!');
                    data?.map((i, index) => (
                        data[index].taskData.profileUpdateRequest = JSON.parse(data[index].taskData.profileUpdateRequest)
                    ))
                    data?.every((md, index) => {
                        if (roleTypeValue.includes(md.taskData.profileUpdateRequest.profileRole.roleType)) {
                            setGetTaskId(md.taskId)
                            console.log('vp--', md, md.taskId);
                            return false
                        }
                        return true
                    })
                }
            }
            else {
                console.log('something went wrong');
            }
        })
    }
    // view profile for not complete
    const viewProfileDataAndTaskId = (roleTypeValue, viewProfileTypeAndStatus) => {
        ApiCall(
            'GET',
            workFlowBaseURL + GET_ALL_PROFILE_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            },
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("I am 500")
                }
                else {
                    console.log('I am 200!');
                    data?.map((i, index) => (
                        data[index].taskData.profileUpdateRequest = JSON.parse(data[index].taskData.profileUpdateRequest)
                    ))
                    data?.every((md, index) => {
                        if (roleTypeValue.includes(md.taskData.profileUpdateRequest.profileRole.roleType)) {
                            setGetTaskId(md.taskId)
                            console.log('vp--', md, md.taskId);
                            //set data for view profile 
                            setCompanyRegNum(md.taskData.profileUpdateRequest?.companyDetails?.registrationNumber);
                            setCompanyName(md.taskData.profileUpdateRequest?.companyDetails?.companyName);
                            setVATRegNum(md.taskData.profileUpdateRequest?.companyDetails?.vatNumber);
                            if (md.taskData.profileUpdateRequest?.companyDetails?.vatRegisteredFlag === 'false') {
                                setisCheckVAT(true);
                                document.getElementById('uploadVAT').style.borderColor = ColorCode.colorCode.black;
                                document.getElementById('vatUpload').style.color = "#C4C4C4";
                                document.getElementById('vatUploadType').style.color = "#C4C4C4";
                                document.getElementById('vatUploadTypeName').style.color = "#C4C4C4";
                                document.getElementById('vatUploadSize').style.color = "#C4C4C4";
                                document.getElementById('vatUploadSizeName').style.color = "#C4C4C4";
                                document.getElementById('vatUploadIcon').src = uploadDisable;
                                document.getElementById('vatFile').style.display = 'none';
                            }
                            else {
                                setisCheckVAT(false);
                            }
                            setFileNameCIPC(md.taskData.profileUpdateRequest?.companyDetails.companyDocument?.documentName);
                            setFilePathCIPC(md.taskData.profileUpdateRequest?.companyDetails.companyDocument?.documentPicture);
                            setUploadFileDisableCIPC(md.taskData.profileUpdateRequest?.companyDetails?.companyDocument?.documentName?.length > 0 ? true : false);
                            setFileNameVAT(md.taskData.profileUpdateRequest?.companyDetails?.vatDocument?.documentName);
                            setFilePathVAT(md.taskData.profileUpdateRequest?.companyDetails?.vatDocument?.documentPicture);
                            setUploadFileDisableVAT(md.taskData.profileUpdateRequest?.companyDetails?.vatDocument?.documentName?.length > 0 ? true : false)
                            // physical address
                            setAddressL1(md.taskData.profileUpdateRequest?.physicalAddress?.addressline1);
                            setAddressL2(md.taskData.profileUpdateRequest?.physicalAddress?.addressline2);
                            setCity(md.taskData.profileUpdateRequest?.physicalAddress?.city);
                            setProvince(md.taskData.profileUpdateRequest?.physicalAddress?.province);
                            setCountry(md.taskData.profileUpdateRequest?.physicalAddress?.countryName);
                            setPostalCode(md.taskData.profileUpdateRequest?.physicalAddress?.postalCode);
                            // postal address
                            setPostalAddressL1(md.taskData.profileUpdateRequest?.postalAddress?.addressline1);
                            setPostalAddressL2(md.taskData.profileUpdateRequest?.postalAddress?.addressline2);
                            setPostalCity(md.taskData.profileUpdateRequest?.postalAddress?.city);
                            setPostalProvince(md.taskData.profileUpdateRequest?.postalAddress?.province);
                            setPostalCountry(md.taskData.profileUpdateRequest?.postalAddress?.countryName);
                            setPostalPostalCode(md.taskData.profileUpdateRequest?.postalAddress?.postalCode);
                            return false
                        }
                        return true
                    })
                }
            }
            else {
                console.log('something went wrong');
                return -1;
            }
        })
    }
    // all apicall's 
    // work flow api for new user
    const workFlowApiReworkRequester = (formAction) => {
        // call rework api 
        ApiCall(
            'POST',
            workFlowBaseURL + REWORK_PROFILE + `?taskId=${getTaskId}`,
            {
                "email": userProfileDataR?.userEmail,
                "firstName": userProfileDataR?.firstName,
                "lastName": userProfileDataR?.lastName,
                "mobileNumber": userProfileDataR?.userMobile,
                "companyDetails": {
                    "companyDocument": {
                        "documentName": fileNameCIPC,
                        "documentPicture": filePathCIPC
                    },
                    "companyName": companyName,
                    "registrationNumber": companyRegNum,
                    "vatDocument": {
                        "documentName": fileNameVAT,
                        "documentPicture": filePathVAT
                    },
                    "vatNumber": vatRegNum,
                    "vatRegisteredFlag": !isCheckVAT
                },
                "physicalAddress": {
                    "addressType": "physical",
                    "addressline1": addressL1,
                    "addressline2": addressL2,
                    "addressline3": "",
                    "addressline4": "",
                    "city": city,
                    "countryName": country,
                    "postalCode": postalCode,
                    "province": province
                },
                "postalAddress": {
                    "addressType": "postal",
                    "addressline1": postalAddressL1,
                    "addressline2": postalAddressL2,
                    "addressline3": "",
                    "addressline4": "",
                    "city": postalCity,
                    "countryName": postalCountry,
                    "postalCode": postalPostalCode,
                    "province": postalProvince
                },
                "profileRole": {
                    "roleId": roleID,
                    "roleName": roleName,
                    "roleType": roleType,
                },
                "userId": userProfileDataR?.userId,
                "submitDate": new Date().getTime()
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                    // show when user perform submit and open modal
                    if (formAction === 'submit') {
                        setHasOpen(true);
                    }
                    // call get user task for fetch task id for save only
                    else {
                        //set save value for second time save calling
                        //get task id
                        viewProfileDataAndTaskId(roleType, profileTypeAndStatus);
                    }
                }
            }
            else {
                console.log('Something went wrong!');
            }
        })
    }
    const workFlowApiReworkRespondent = (formAction) => {
        ApiCall(
            'POST',
            workFlowBaseURL + REWORK_PROFILE + `?taskId=${getTaskId}`,
            {
                "email": userProfileDataR?.userEmail,
                "firstName": userProfileDataR?.firstName,
                "lastName": userProfileDataR?.lastName,
                "mobileNumber": userProfileDataR?.userMobile,
                // "approved": true,
                "bankDetails": {
                    "accountDocument": {
                        "documentName": "",
                        "documentPicture": ''
                    },
                    "accountName": '',
                    "accountNumber": '',
                    "bankAddress": '',
                    "bankName": "",
                    "branchCode": '',
                    "branchName": ''
                },
                // "comments": "string",
                "companyDetails": {
                    "companyDocument": {
                        "documentName": fileNameCIPC,
                        "documentPicture": filePathCIPC
                    },
                    "companyName": companyName,
                    "registrationNumber": companyRegNum,
                    "vatDocument": {
                        "documentName": fileNameVAT,
                        "documentPicture": filePathVAT
                    },
                    "vatNumber": vatRegNum,
                    "vatRegisteredFlag": !isCheckVAT
                },
                "physicalAddress": {
                    "addressType": "physical",
                    "addressline1": addressL1,
                    "addressline2": addressL2,
                    "addressline3": "",
                    "addressline4": "",
                    "city": city,
                    "countryName": country,
                    "postalCode": postalCode,
                    "province": province
                },
                "postalAddress": {
                    "addressType": "postal",
                    "addressline1": postalAddressL1,
                    "addressline2": postalAddressL2,
                    "addressline3": "",
                    "addressline4": "",
                    "city": postalCity,
                    "countryName": postalCountry,
                    "postalCode": postalPostalCode,
                    "province": postalProvince
                },
                "profileRole": {
                    "roleId": roleID,
                    "roleName": roleName,
                    "roleType": roleType
                },
                "userId": userProfileDataR?.userId,
                "submitDate": new Date().getTime()
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    //get task id
                    viewProfileDataAndTaskId(roleType, profileTypeAndStatus);
                }
            }
            else {
                console.log('Something went wrong!');
            }
        });
    }
    const workFlowApiNewRequester = (formAction) => {
        ApiCall(
            'POST',
            workFlowBaseURL + START_PROFILE_ENDPOINT + `?action=${formAction}`,
            {
                "email": userProfileDataR?.userEmail,
                "firstName": userProfileDataR?.firstName,
                "lastName": userProfileDataR?.lastName,
                "mobileNumber": userProfileDataR?.userMobile,
                "bankDetails": {
                    "accountDocument": {
                        "documentName": "",
                        "documentPicture": ''
                    },
                    "accountName": '',
                    "accountNumber": '',
                    "bankAddress": '',
                    "bankName": "",
                    "branchCode": '',
                    "branchName": ''
                },
                "companyDetails": {
                    "companyDocument": {
                        "documentName": fileNameCIPC,
                        "documentPicture": filePathCIPC
                    },
                    "companyName": companyName,
                    "registrationNumber": companyRegNum,
                    "vatDocument": {
                        "documentName": fileNameVAT,
                        "documentPicture": filePathVAT
                    },
                    "vatNumber": vatRegNum,
                    "vatRegisteredFlag": !isCheckVAT
                },
                "physicalAddress": {
                    "addressType": "physical",
                    "addressline1": addressL1,
                    "addressline2": addressL2,
                    "addressline3": "",
                    "addressline4": "",
                    "city": city,
                    "countryName": country,
                    "postalCode": postalCode,
                    "province": province
                },
                "postalAddress": {
                    "addressType": "postal",
                    "addressline1": postalAddressL1,
                    "addressline2": postalAddressL2,
                    "addressline3": "",
                    "addressline4": "",
                    "city": postalCity,
                    "countryName": postalCountry,
                    "postalCode": postalPostalCode,
                    "province": postalProvince
                },
                "profileRole": {
                    "roleId": roleID,
                    "roleName": roleName,
                    "roleType": roleType,
                },
                "userId": userProfileDataR?.userId,
                "submitDate": new Date().getTime()
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                    // show when user perform submit and open modal
                    if (formAction === 'submit') {
                        setHasOpen(true);
                    }
                    // call get user task for fetch task id for save only
                    else {
                        //set save value for second time save calling
                        //get task id
                        viewProfileDataAndTaskId(roleType, profileTypeAndStatus);
                    }
                }
            }
            else {
                console.log('Something went wrong!');
            }
        })
    }
    const workFlowApiCompleteRequester = (formAction) => {
        // api call for task id work flow task id
        ApiCall(
            'GET',
            workFlowBaseURL + GET_ALL_PROFILE_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            },
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("I am 500")
                }
                else {
                    console.log('I am 200!');
                    console.log('data----1', data[0].taskData.profileCompletionNextState);
                    data?.map((i, index) => (
                        data[index].taskData.profileUpdateRequest = JSON.parse(data[index].taskData.profileUpdateRequest)
                    ))
                    console.log('data------2', data[0].taskData.profileCompletionNextState);
                    data?.every((md, index) => {
                        if (roleType.includes(md.taskData.profileUpdateRequest.profileRole.roleType)) {
                            console.log('md', md, md.taskId);
                            setGetTaskId(md.taskId);
                            tempTaskId = md.taskId;
                            return false
                        }
                        return true
                    })
                    ApiCall(
                        'POST',
                        workFlowBaseURL + COMPLETE_PROFILE_FORM_ENDPOINT + `?action=${formAction}&taskId=${tempTaskId}&userId=${userProfileDataR?.userId}`,
                        {
                            "email": userProfileDataR?.userEmail,
                            "firstName": userProfileDataR?.firstName,
                            "lastName": userProfileDataR?.lastName,
                            "mobileNumber": userProfileDataR?.userMobile,
                            "bankDetails": {
                                "accountDocument": {
                                    "documentName": "",
                                    "documentPicture": ''
                                },
                                "accountName": '',
                                "accountNumber": '',
                                "bankAddress": '',
                                "bankName": "",
                                "branchCode": '',
                                "branchName": ''
                            },
                            "companyDetails": {
                                "companyDocument": {
                                    "documentName": fileNameCIPC,
                                    "documentPicture": filePathCIPC
                                },
                                "companyName": companyName,
                                "registrationNumber": companyRegNum,
                                "vatDocument": {
                                    "documentName": fileNameVAT,
                                    "documentPicture": filePathVAT
                                },
                                "vatNumber": vatRegNum,
                                "vatRegisteredFlag": !isCheckVAT
                            },
                            "physicalAddress": {
                                "addressType": "physical",
                                "addressline1": addressL1,
                                "addressline2": addressL2,
                                "addressline3": "",
                                "addressline4": "",
                                "city": city,
                                "countryName": country,
                                "postalCode": postalCode,
                                "province": province
                            },
                            "postalAddress": {
                                "addressType": "postal",
                                "addressline1": postalAddressL1,
                                "addressline2": postalAddressL2,
                                "addressline3": "",
                                "addressline4": "",
                                "city": postalCity,
                                "countryName": postalCountry,
                                "postalCode": postalPostalCode,
                                "province": postalProvince
                            },
                            "profileRole": {
                                "roleId": roleID,
                                "roleName": roleName,
                                "roleType": roleType
                            },
                            "userId": userProfileDataR?.userId,
                            "submitDate": new Date().getTime()
                        },
                        {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        }
                    ).then(apiData => {
                        if (apiData.flag != -1) {
                            if (apiData.flag == '500') {
                                console.log('I am 500!');
                            } else {
                                console.log('I am 200!');
                                // for show when user submit profile
                                if (formAction === 'submit') {
                                    setHasOpen(true);
                                }
                            }
                        }
                        else {
                            console.log('Something went wrong!');
                        }
                    });
                    return data;
                }
            }
            else {
                console.log('something went wrong');
                return -1;
            }
        })
    }
    const workFlowApiNewRespondent = (formAction) => {
        ApiCall(
            'POST',
            workFlowBaseURL + START_PROFILE_ENDPOINT + `?action=${formAction}`,
            {
                "email": userProfileDataR?.userEmail,
                "firstName": userProfileDataR?.firstName,
                "lastName": userProfileDataR?.lastName,
                "mobileNumber": userProfileDataR?.userMobile,
                // "approved": true,
                "bankDetails": {
                    "accountDocument": {
                        "documentName": "",
                        "documentPicture": ''
                    },
                    "accountName": '',
                    "accountNumber": '',
                    "bankAddress": '',
                    "bankName": "",
                    "branchCode": '',
                    "branchName": ''
                },
                // "comments": "string",
                "companyDetails": {
                    "companyDocument": {
                        "documentName": fileNameCIPC,
                        "documentPicture": filePathCIPC
                    },
                    "companyName": companyName,
                    "registrationNumber": companyRegNum,
                    "vatDocument": {
                        "documentName": fileNameVAT,
                        "documentPicture": filePathVAT
                    },
                    "vatNumber": vatRegNum,
                    "vatRegisteredFlag": !isCheckVAT
                },
                "physicalAddress": {
                    "addressType": "physical",
                    "addressline1": addressL1,
                    "addressline2": addressL2,
                    "addressline3": "",
                    "addressline4": "",
                    "city": city,
                    "countryName": country,
                    "postalCode": postalCode,
                    "province": province
                },
                "postalAddress": {
                    "addressType": "postal",
                    "addressline1": postalAddressL1,
                    "addressline2": postalAddressL2,
                    "addressline3": "",
                    "addressline4": "",
                    "city": postalCity,
                    "countryName": postalCountry,
                    "postalCode": postalPostalCode,
                    "province": postalProvince
                },
                "profileRole": {
                    "roleId": roleID,
                    "roleName": roleName,
                    "roleType": roleType
                },
                "userId": userProfileDataR?.userId,
                "submitDate": new Date().getTime()
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    //view profile with Approved status then save the data and redirect to bank info
                    if (["Approved", "approved", "APPROVED"].includes(profileTypeAndStatus)) {
                        history.push({
                            pathname: `/bankInfo/${roleID}/${roleType}/${roleName}/${profileTypeAndStatus}`,
                        });
                    } else if (formAction === 'save') {
                        //get task id
                        viewProfileDataAndTaskId(roleType, profileTypeAndStatus);
                    }
                }
            }
            else {
                console.log('Something went wrong!');
            }
        });
    }
    const workFlowApiCompleteRespondent = (formAction) => {
        // api call for task id work flow task id
        ApiCall(
            'GET',
            workFlowBaseURL + GET_ALL_PROFILE_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            },
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("I am 500")
                }
                else {
                    console.log('I am 200!');
                    console.log('data----1', data[0].taskData.profileCompletionNextState);
                    data?.map((i, index) => (
                        data[index].taskData.profileUpdateRequest = JSON.parse(data[index].taskData.profileUpdateRequest)
                    ))
                    console.log('data------2', data[0].taskData.profileCompletionNextState);
                    data?.every((md, index) => {
                        if (roleType.includes(md.taskData.profileUpdateRequest.profileRole.roleType)) {
                            console.log('md--', md, md.taskId);
                            setGetTaskId(md.taskId);
                            tempTaskId = md.taskId;
                            bankDetailsOfRespondent = md;
                            return false
                        }
                        return true
                    });
                    // api call for complete respondent profile
                    ApiCall(
                        'POST',
                        workFlowBaseURL + COMPLETE_PROFILE_FORM_ENDPOINT + `?action=${formAction}&taskId=${tempTaskId}&userId=${userProfileDataR?.userId}`,
                        {
                            "email": userProfileDataR?.userEmail,
                            "firstName": userProfileDataR?.firstName,
                            "lastName": userProfileDataR?.lastName,
                            "mobileNumber": userProfileDataR?.userMobile,
                            // "approved": true,
                            "bankDetails": {
                                "accountDocument": {
                                    "documentName": bankDetailsOfRespondent?.taskData.profileUpdateRequest.bankDetails.accountDocument.documentName,
                                    "documentPicture": bankDetailsOfRespondent?.taskData.profileUpdateRequest.bankDetails.accountDocument.documentPicture
                                },
                                "accountName": bankDetailsOfRespondent?.taskData.profileUpdateRequest.bankDetails.accountName,
                                "accountNumber": bankDetailsOfRespondent?.taskData.profileUpdateRequest.bankDetails.accountNumber,
                                "bankAddress": bankDetailsOfRespondent?.taskData.profileUpdateRequest.bankDetails.bankAddress,
                                "bankName": bankDetailsOfRespondent?.taskData.profileUpdateRequest.bankDetails.bankName,
                                "branchCode": bankDetailsOfRespondent?.taskData.profileUpdateRequest.bankDetails.branchCode,
                                "branchName": bankDetailsOfRespondent?.taskData.profileUpdateRequest.bankDetails.branchName
                            },
                            // "comments": "string",
                            "companyDetails": {
                                "companyDocument": {
                                    "documentName": fileNameCIPC,
                                    "documentPicture": filePathCIPC
                                },
                                "companyName": companyName,
                                "registrationNumber": companyRegNum,
                                "vatDocument": {
                                    "documentName": fileNameVAT,
                                    "documentPicture": filePathVAT
                                },
                                "vatNumber": vatRegNum,
                                "vatRegisteredFlag": !isCheckVAT
                            },
                            "physicalAddress": {
                                "addressType": "physical",
                                "addressline1": addressL1,
                                "addressline2": addressL2,
                                "addressline3": "",
                                "addressline4": "",
                                "city": city,
                                "countryName": country,
                                "postalCode": postalCode,
                                "province": province
                            },
                            "postalAddress": {
                                "addressType": "postal",
                                "addressline1": postalAddressL1,
                                "addressline2": postalAddressL2,
                                "addressline3": "",
                                "addressline4": "",
                                "city": postalCity,
                                "countryName": postalCountry,
                                "postalCode": postalPostalCode,
                                "province": postalProvince
                            },
                            "profileRole": {
                                "roleId": roleID,
                                "roleName": roleName,
                                "roleType": roleType
                            },
                            "userId": userProfileDataR?.userId,
                            "submitDate": new Date().getTime()
                        },
                        {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        }
                    ).then(apiData => {
                        if (apiData.flag != -1) {
                            if (apiData.flag == '500') {
                                console.log('I am 500!');
                            }
                            else {
                                console.log('I am 200!');
                                if (["Approved", "approved", "APPROVED"].includes(profileTypeAndStatus)) {
                                    history.push({
                                        pathname: `/bankInfo/${roleID}/${roleType}/${roleName}/${profileTypeAndStatus}`,
                                    });
                                }
                            }
                        }
                        else {
                            console.log('Something went wrong!');
                        }
                    });
                }
            }
            else {
                console.log('Something went wrong!');
            }
        });
    }
    const editClicked = () => {
        setClickEdit(true);
        setClickSave(false);
        setClickContinue(false);
        setClickCheckbox(false);
        if (profileApproved.includes(profileTypeAndStatus) || profileReject.includes(profileTypeAndStatus)) {
            setClickContinue(true);
        }
    }
    const saveClicked = event => {
        event.preventDefault();
        setCompanyName(companyName);
        setCompanyRegNum(companyRegNum);
        setVATRegNum(vatRegNum);
        setAddressL1(addressL1);
        setAddressL2(addressL2);
        setCity(city);
        setProvince(province);
        setCountry(country);
        setPostalCode(postalCode);
        setPostalAddressL1(postalAddressL1);
        setPostalAddressL2(postalAddressL2);
        setPostalCity(postalCity);
        setPostalProvince(postalProvince);
        setPostalCountry(postalCountry);
        setPostalPostalCode(postalPostalCode);
        setClickEdit(false);
        setClickSave(true);
        setClickContinue(true);
        setClickCheckbox(true);
        // api call for new user save
        if (profileTypeAndStatus === 'add-profile' && roleType === 'Requester' && !getTaskId) {
            workFlowApiNewRequester('save');
        }
        else if (profileTypeAndStatus === 'add-profile' && roleType === 'Respondent' && !getTaskId) {
            workFlowApiNewRespondent('save');
        }
        // api call for new user second time api call
        if (profileTypeAndStatus === 'add-profile' && roleType === 'Requester' && getTaskId) {
            workFlowApiCompleteRequester('save');
        }
        else if (profileTypeAndStatus === 'add-profile' && roleType === 'Respondent' && getTaskId) {
            workFlowApiCompleteRespondent('save');
        }
        //api call for complete task SAVE API CALL FOR EXISTING USER COMPLETE FORM
        // view profile check status
        if (roleType === 'Requester' && ["Not Completed", 'Not completed', "not completed", "NOT COMPLETED"].includes(profileTypeAndStatus)) {
            workFlowApiCompleteRequester('save');
        }
        else if (roleType === "Requester" && ["Rejected", "rejected", "REJECTED"].includes(profileTypeAndStatus)) {
            workFlowApiReworkRequester('save');
        }
        else if (roleType === 'Respondent' && ["Not Completed", 'Not completed', "not completed", "NOT COMPLETED"].includes(profileTypeAndStatus)) {
            workFlowApiCompleteRespondent('save');
        } else if (roleType === "Respondent" && ["Rejected", "rejected", "REJECTED"].includes(profileTypeAndStatus)) {
            // rework respondent
            workFlowApiReworkRespondent('save');
        }
    }
    const alertContinue = () => {
        toast("Please click save to continue.", { position: toast.POSITION.TOP_CENTER, style: { color: "red" } });
    }
    //VAT info check box function
    const toggleCheckVAT = (props) => {
        if (!isCheckVAT) {
            setVATRegNum("");
            setVATRegNumError();
            setFileUpload1Error();
            document.getElementById('vatRegNum').disabled = true;
            document.getElementById('vatRegNum').style.borderColor = ColorCode.colorCode.black;
            document.getElementById('uploadVAT').style.borderColor = ColorCode.colorCode.black;
            //disable upload
            document.getElementById('upload1').disabled = true;
            document.getElementById('vatUpload').style.color = "#C4C4C4";
            document.getElementById('vatUploadType').style.color = "#C4C4C4";
            document.getElementById('vatUploadTypeName').style.color = "#C4C4C4";
            document.getElementById('vatUploadSize').style.color = "#C4C4C4";
            document.getElementById('vatUploadSizeName').style.color = "#C4C4C4";
            document.getElementById('vatUploadIcon').src = uploadDisable;
            document.getElementById('vatFile').style.display = 'none';
        } else if (isCheckVAT) {
            document.getElementById('vatRegNum').disabled = false;
            document.getElementById('upload1').disabled = false;
            document.getElementById('vatUpload').style.color = "#d42e12";
            document.getElementById('vatUploadType').style.color = "#737373";
            document.getElementById('vatUploadTypeName').style.color = "#000000";
            document.getElementById('vatUploadSize').style.color = "#737373";
            document.getElementById('vatUploadSizeName').style.color = "#000000";
            document.getElementById('vatUploadIcon').src = uploadEnable;
            document.getElementById('vatFile').style.display = 'none';
            setFileNameVAT('');
            setFilePathVAT('');
            // delete file
            document.querySelector('#vatFile img').click();
        }
        setisCheckVAT(!isCheckVAT);
    }
    const toggleCheckPostalAddress = () => {
        setpostalAddressCheck(!postalAddressCheck);
    }
    const onCloseModal = () => {
        setHasOpen(false);
        history.push('/home');
    };
    const onClosePending = () => {
        setHasOpenPending(false);
    };
    const handleChangeCompanyName = (e) => {
        setCompanyName(e.target.value);
        setCompanyNameError();
        document.getElementById('companyName').style.borderColor = ColorCode.colorCode.black;
    }
    const handleChangeCompanyRegNum = (e) => {
        setCompanyRegNum(e.target.value);
        setCompanyRegNumError();
        document.getElementById('companyRegNum').style.borderColor = ColorCode.colorCode.black;
    }
    const handleChangeVATRegNum = (e) => {
        setVATRegNum(e.target.value);
        setVATRegNumError();
        document.getElementById('vatRegNum').style.borderColor = ColorCode.colorCode.black;
    }
    const handleChangeAddressL1 = (e) => {
        setAddressL1(e.target.value);
        setAddressL1Error();
        document.getElementById('addressL1').style.borderColor = ColorCode.colorCode.black;
        if (postalAddressCheck) {
            setPostalAddressL1(e.target.value);
        }
    }
    const handleChangeAddressL2 = (e) => {
        setAddressL2(e.target.value);
        if (postalAddressCheck) {
            setPostalAddressL2(e.target.value);
        }
    }
    const handleChangeCity = (e) => {
        setCity(e.target.value);
        setCityError();
        document.getElementById('city').style.borderColor = ColorCode.colorCode.black;
        if (postalAddressCheck) {
            setPostalCity(e.target.value);
        }
    }
    const handleChangeProvince = (e) => {
        setProvince(e.target.value);
        setProvinceError();
        document.getElementById('province').style.borderColor = ColorCode.colorCode.black;
        if (postalAddressCheck) {
            setPostalProvince(e.target.value);
        }
    }
    const handleChangeCountry = (e) => {
        setCountry(e.target.value);
        setCountryError();
        document.getElementById('country').style.borderColor = ColorCode.colorCode.black;
        if (postalAddressCheck) {
            setPostalCountry(e.target.value);
        }
    }
    const handleChangePostalCode = (e) => {
        setPostalCode(e.target.value);
        setPostalCodeError();
        document.getElementById('postalCode').style.borderColor = ColorCode.colorCode.black;
        if (postalAddressCheck) {
            setPostalPostalCode(e.target.value);
        }
    }
    const handleChangePostalAddressL1 = (e) => {
        setPostalAddressL1(e.target.value);
        setPostalAddressL1Error();
        document.getElementById('postalAddressL1').style.borderColor = ColorCode.colorCode.black;
    }
    const handleChangePostalAddressL2 = (e) => {
        setPostalAddressL2(e.target.value);
    }
    const handleChangePostalCity = (e) => {
        setPostalCity(e.target.value);
        setPostalCityError();
        document.getElementById('postalCity').style.borderColor = ColorCode.colorCode.black;
    }
    const handleChangePostalProvince = (e) => {
        setPostalProvince(e.target.value);
        setPostalProvinceError();
        document.getElementById('postalProvince').style.borderColor = ColorCode.colorCode.black;
    }
    const handleChangePostalCountry = (e) => {
        setPostalCountry(e.target.value);
        setPostalCountryError();
        document.getElementById('postalCountry').style.borderColor = ColorCode.colorCode.black;
    }
    const handleChangePostalPostalCode = (e) => {
        setPostalPostalCode(e.target.value);
        setPostalPostalCodeError();
        document.getElementById('postalPostalCode').style.borderColor = ColorCode.colorCode.black;
    }
    const onSubmit = event => {
        event.preventDefault();
        if (validate()) {
            setCompanyName(companyName);
            setCompanyRegNum(companyRegNum);
            setVATRegNum(vatRegNum);
            setAddressL1(addressL1);
            setAddressL2(addressL2);
            setCity(city);
            setProvince(province);
            setCountry(country);
            setPostalCode(postalCode);
            setPostalAddressL1(postalAddressL1);
            setPostalAddressL2(postalAddressL2);
            setPostalCity(postalCity);
            setPostalProvince(postalProvince);
            setPostalCountry(postalCountry);
            setPostalPostalCode(postalPostalCode);
            //view profile case for respondent
            if (profilePending.includes(profileTypeAndStatus) || profileApproved.includes(profileTypeAndStatus) || profileIncomplete.includes(profileTypeAndStatus) || profileReject.includes(profileTypeAndStatus)) {
                if (roleType == "Respondent" || roleType == "Requester") {
                    if (['Not Completed', 'Not completed', 'not completed', 'NOT COMPLETED', 'PENDING', 'Pending', 'pending'].includes(profileTypeAndStatus)) {
                        if (clickContinue) {
                            history.push({
                                pathname: `/bankInfo/${roleID}/${roleType}/${roleName}/${profileTypeAndStatus}`,
                            });
                        } else {
                            alertContinue();
                        }
                    } else if (["Approved", "approved", "APPROVED"].includes(profileTypeAndStatus) && !getTaskId) {
                        // view profile and status approved then call start profile
                        workFlowApiNewRespondent('save');
                    } else if (["Approved", "approved", "APPROVED"].includes(profileTypeAndStatus) && getTaskId) {
                        // view profile and status approved then call start profile
                        workFlowApiCompleteRespondent('save');
                    }
                    else if (['Rejected', 'rejected', 'REJECTED'].includes(profileTypeAndStatus)) {
                        history.push({
                            pathname: `/bankInfo/${roleID}/${roleType}/${roleName}/${profileTypeAndStatus}`,
                            state: {
                                companyName: companyName,
                                companyRegNum: companyRegNum,
                                filePathCIPC: filePathCIPC,
                                fileNameCIPC: fileNameCIPC,
                                vatRegNum: vatRegNum,
                                filePathVAT: filePathVAT,
                                fileNameVAT: fileNameVAT,
                                isCheckVAT: !isCheckVAT,
                                // physical address
                                addressL1: addressL1,
                                addressL2: addressL2,
                                city: city,
                                country: country,
                                postalCode: postalCode,
                                province: province,
                                // postal addresss
                                postalAddressL1: postalAddressL1,
                                postalAddressL2: postalAddressL2,
                                postalCity: postalCity,
                                postalCountry: postalCountry,
                                postalPostalCode: postalPostalCode,
                                postalProvince: postalProvince
                            }
                        });
                    }
                }
            }
            // add profile case for respondent
            else if (roleType === "Respondent" || roleType === "Requester" && profileTypeAndStatus === 'add-profile') {
                if (clickContinue) {
                    history.push({
                        pathname: `/bankInfo/${roleID}/${roleType}/${roleName}/${"add-profile"}`,
                    });
                }
                else {
                    alertContinue();
                }
            }
        }
    };
    const copyAddress = () => {
        if (!postalAddressCheck) {
            setPostalAddressL1(addressL1);
            setPostalAddressL2(addressL2);
            setPostalCity(city);
            setPostalProvince(province);
            setPostalCountry(country);
            setPostalPostalCode(postalCode);
            setPostalAddressL1Error();
            setPostalCityError();
            setPostalProvinceError();
            setPostalCountryError();
            setPostalPostalCodeError();
            document.getElementById('postalAddressL1').style.borderColor = ColorCode.colorCode.black;
            document.getElementById('postalCity').style.borderColor = ColorCode.colorCode.black;
            document.getElementById('postalProvince').style.borderColor = ColorCode.colorCode.black;
            document.getElementById('postalCountry').style.borderColor = ColorCode.colorCode.black;
            document.getElementById('postalPostalCode').style.borderColor = ColorCode.colorCode.black;
        }
        else {
            setPostalAddressL1("");
            setPostalAddressL2("");
            setPostalCity("");
            setPostalProvince("");
            setPostalPostalCode("");
            setPostalCountry("South Africa");
        }
    };
    const validate = () => {
        //let errors = {};
        let isValid = true;
        var patternCharacter = new RegExp(/^[a-zA-Z ]*$/);
        var patternDigit = new RegExp(/^[0-9\b]+$/);
        var patternAlphaNumeric = new RegExp(/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]+$/);
        if (fileNameCIPC?.length === 0 && filePathCIPC?.length === 0) {
            isValid = false;
            fileUploadError = Message.validation.required;
            document.getElementById('uploadCIPC').style.borderColor = ColorCode.colorCode.red;
        } else {
            fileUploadError = "";
            document.getElementById('uploadCIPC').style.borderColor = ColorCode.colorCode.black;
        }
        if (!isCheckVAT) {
            if (fileNameVAT?.length === 0 && filePathVAT?.length === 0) {
                isValid = false;
                fileUpload1Error = Message.validation.required;
                document.getElementById('uploadVAT').style.borderColor = ColorCode.colorCode.red;
            } else {
                fileUpload1Error = "";
                document.getElementById('uploadVAT').style.borderColor = ColorCode.colorCode.black;
            }
        } else {
            setFileUpload1Error("");
            document.getElementById('uploadVAT').style.borderColor = ColorCode.colorCode.black;
        }
        if (!companyName) {
            isValid = false;
            companyNameError = Message.validation.required;
            document.getElementById('companyName').style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementById('companyName').style.borderColor = ColorCode.colorCode.black;
        }
        if (!companyRegNum) {
            isValid = false;
            companyRegNumError = Message.validation.required;
            document.getElementById('companyRegNum').style.borderColor = ColorCode.colorCode.red;
        } else if (patternCharacter.test(companyRegNum) || patternAlphaNumeric.test(companyRegNum)) {
            isValid = false;
            companyRegNumError = "Please enter numbers and special characters";
            document.getElementById('companyRegNum').style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementById('companyRegNum').style.borderColor = ColorCode.colorCode.black;
        }
        if (profileTypeAndStatus == 'add-profile') {
            if (!isCheckVAT && !clickEdit) {
                if (!vatRegNum) {
                    isValid = false;
                    vatRegNumError = Message.validation.required;
                    document.getElementById('vatRegNum').style.borderColor = ColorCode.colorCode.red;
                } else if (!patternDigit.test(vatRegNum)) {
                    isValid = false;
                    vatRegNumError = Message.validation.num;
                    document.getElementById('vatRegNum').style.borderColor = ColorCode.colorCode.red;
                }
            }
        }
        else if (!isCheckVAT && clickEdit) {
            if (!vatRegNum) {
                isValid = false;
                vatRegNumError = Message.validation.required;
                document.getElementById('vatRegNum').style.borderColor = ColorCode.colorCode.red;
            } else if (!patternDigit.test(vatRegNum)) {
                isValid = false;
                vatRegNumError = Message.validation.num;
                document.getElementById('vatRegNum').style.borderColor = ColorCode.colorCode.red;
            }
        }
        if (!addressL1) {
            isValid = false;
            addressL1Error = Message.validation.required;
            document.getElementById('addressL1').style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementById('addressL1').style.borderColor = ColorCode.colorCode.black;
        }
        if (!city) {
            isValid = false;
            cityError = Message.validation.required;
            document.getElementById('city').style.borderColor = ColorCode.colorCode.red;
        } else if (!patternCharacter.test(city)) {
            isValid = false;
            cityError = Message.validation.alpha;
            document.getElementById('city').style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementById('city').style.borderColor = ColorCode.colorCode.black;
        }
        if (!province) {
            isValid = false;
            provinceError = Message.validation.required;
            document.getElementById('province').style.borderColor = ColorCode.colorCode.red;
        } else if (!patternCharacter.test(province)) {
            isValid = false;
            provinceError = Message.validation.alpha;
            document.getElementById('province').style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementById('province').style.borderColor = ColorCode.colorCode.black;
        }
        if (!postalCode) {
            isValid = false;
            postalCodeError = Message.validation.required;
            document.getElementById('postalCode').style.borderColor = ColorCode.colorCode.red;
        } else if (!patternDigit.test(postalCode)) {
            isValid = false;
            postalCodeError = Message.validation.num;
            document.getElementById('postalCode').style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementById('postalCode').style.borderColor = ColorCode.colorCode.black;
        }
        if (!postalAddressCheck) {
            if (!postalAddressL1) {
                isValid = false;
                postalAddressL1Error = Message.validation.required;
                document.getElementById('postalAddressL1').style.borderColor = ColorCode.colorCode.red;
            } else {
                document.getElementById('postalAddressL1').style.borderColor = ColorCode.colorCode.black;
            }
            if (!postalCity) {
                isValid = false;
                postalCityError = Message.validation.required;
                document.getElementById('postalCity').style.borderColor = ColorCode.colorCode.red;
            } else if (!patternCharacter.test(postalCity)) {
                isValid = false;
                postalCityError = Message.validation.alpha;
                document.getElementById('postalCity').style.borderColor = ColorCode.colorCode.red;
            } else {
                document.getElementById('postalCity').style.borderColor = ColorCode.colorCode.black;
            }
            if (!postalProvince) {
                isValid = false;
                postalProvinceError = Message.validation.required;
                document.getElementById('postalProvince').style.borderColor = ColorCode.colorCode.red;
            } else if (!patternCharacter.test(postalProvince)) {
                isValid = false;
                postalProvinceError = Message.validation.alpha;
                document.getElementById('postalProvince').style.borderColor = ColorCode.colorCode.red;
            } else {
                document.getElementById('postalProvince').style.borderColor = ColorCode.colorCode.black;
            }
            if (!postalPostalCode) {
                isValid = false;
                postalPostalCodeError = Message.validation.required;
                document.getElementById('postalPostalCode').style.borderColor = ColorCode.colorCode.red;
            } else if (!patternDigit.test(postalPostalCode)) {
                isValid = false;
                postalPostalCodeError = Message.validation.num;
                document.getElementById('postalPostalCode').style.borderColor = ColorCode.colorCode.red;
            } else {
                document.getElementById('postalPostalCode').style.borderColor = ColorCode.colorCode.black;
            }
        } else {
            setPostalAddressL1Error();
            setPostalCityError();
            setPostalProvinceError();
            setPostalCountryError();
            setPostalPostalCodeError();
            document.getElementById('postalAddressL1').style.borderColor = ColorCode.colorCode.black;
            document.getElementById('postalCity').style.borderColor = ColorCode.colorCode.black;
            document.getElementById('postalProvince').style.borderColor = ColorCode.colorCode.black;
            document.getElementById('postalCountry').style.borderColor = ColorCode.colorCode.black;
            document.getElementById('postalPostalCode').style.borderColor = ColorCode.colorCode.black;
        }
        //setErrors(errors);
        setCompanyNameError(companyNameError);
        setCompanyRegNumError(companyRegNumError);
        setVATRegNumError(vatRegNumError);
        setAddressL1Error(addressL1Error);
        setCityError(cityError);
        setProvinceError(provinceError);
        setCountryError(countryError);
        setPostalCodeError(postalCodeError);
        setPostalAddressL1Error(postalAddressL1Error);
        setPostalCityError(postalCityError);
        setPostalProvinceError(postalProvinceError);
        setPostalCountryError(postalCountryError);
        setPostalPostalCodeError(postalPostalCodeError);
        setFileUploadError(fileUploadError);
        setFileUpload1Error(fileUpload1Error);
        return isValid;
    }
    return (
        <div class="CompanyPageColor">
            <MetaDecorator title={TitleDescription.companyInfoPageTitle} description={TitleDescription.companyInfoPageDescription} />
            <div class="fullBankInfo" id={pageDisable ? "disabletrue" : ""}>
                <Header tilesFetched={() => { }} />
                <div id="CompanyBoxDiv">
                    <div className="" class="Companynavbar">
                        <div className="Companynavbarname">
                            <small id="navc">My Profile</small>
                        </div>
                        <div class="Companynavsave ">
                            {
                                phone ?
                                    <div>
                                        {
                                            profileApproved.includes(profileTypeAndStatus) || profileReject.includes(profileTypeAndStatus) ?
                                                <div>
                                                    {
                                                        clickEdit ?
                                                            <div>
                                                                <img src={editlight} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                <small id="editlight" class=" pr-4" >Edit</small>
                                                            </div>
                                                            :
                                                            <div>
                                                                <img src={edit} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                <small id="edit" class=" pr-4" onClick={editClicked} >Edit</small>
                                                            </div>
                                                    }
                                                </div>
                                                :
                                                <div>
                                                    {
                                                        profilePending.includes(profileTypeAndStatus) ?
                                                            <div>
                                                                <img src={editlight} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                <small id="editlight" class=" pr-4" >Edit</small>
                                                                <img src={save} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                                <small id="save" >Save</small>
                                                            </div>
                                                            :
                                                            <div>
                                                                {
                                                                    profileIncomplete.includes(profileTypeAndStatus) ?
                                                                        <div>
                                                                            {
                                                                                clickEdit ?
                                                                                    <div>
                                                                                        <img src={editlight} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                                        <small id="editlight" class=" pr-4" >Edit</small>
                                                                                        <img src={savedark} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                                                        <small id="savedark" onClick={saveClicked} >Save</small>
                                                                                    </div>
                                                                                    :
                                                                                    <div>
                                                                                        <img src={edit} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                                        <small id="edit" class=" pr-4" onClick={editClicked} >Edit</small>
                                                                                        <img src={save} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                                                        <small id="save" >Save</small>
                                                                                    </div>
                                                                            }
                                                                        </div>
                                                                        :
                                                                        <div>
                                                                            {clickEdit ?
                                                                                <div>
                                                                                    <img src={editlight} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                                    <small id="editlight" class=" pr-4" >Edit</small>
                                                                                    <img src={savedark} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                                                    <small id="savedark" onClick={saveClicked} >Save</small>
                                                                                </div>
                                                                                :
                                                                                <div>
                                                                                    <img src={edit} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                                    <small id="edit" class=" pr-4" onClick={editClicked} >Edit</small>
                                                                                    <img src={save} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                                                    <small id="save" >Save</small>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                }
                                                            </div>
                                                    }
                                                </div>
                                        }
                                    </div>
                                    :
                                    <div>
                                        {clickSave ?
                                            <div>
                                                <img src={edit} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                <small id="edit" class=" pr-4" onClick={editClicked} >Edit</small>
                                                <img src={save} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                <small id="save" >Save</small>
                                            </div>
                                            :
                                            <div>
                                                <img src={editlight} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                <small id="editlight" class=" pr-4" >Edit</small>
                                                <img src={savedark} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                <small id="savedark" onClick={saveClicked} >Save</small>
                                            </div>
                                        }
                                    </div>
                            }
                        </div>
                    </div>
                    <hr class="hr1" />
                    <div class="maincardBankInfo">
                        <div id={clickSave || (phone && !clickEdit) ? "MakeCompanyFormDivPointerNone" : "MakeCompanyFormDivPointable"}>
                            <div class="bankbank1">
                                <small id="CompanyCardHaeding">Company Information</small>
                            </div>
                            <div class="CompanyOuterCardCss">
                                <div class="CompanyDivCardCss">
                                    <div class="CompanyInputDivCss">
                                        <small id="name">Company Registration Number</small>
                                        <br />
                                        <Input
                                            class="input"
                                            onKeyDown={handleKeyDown}
                                            type="text"
                                            id="companyRegNum"
                                            name="companyRegNum"
                                            autoComplete="off"
                                            value={companyRegNum}
                                            readOnly={clickSave || (phone && !clickEdit)}
                                            onChange={handleChangeCompanyRegNum} />
                                        <div className="bankinfoerror12">{companyRegNumError}</div>
                                    </div>
                                    <div class="CompanyInputDivCss">
                                        <small id="name">Company Name</small>
                                        <br />
                                        <Input
                                            class="input"
                                            type="text"
                                            id="companyName"
                                            name="companyName"
                                            autoComplete="off"
                                            value={companyName}
                                            readOnly={clickSave || (phone && !clickEdit)}
                                            onChange={handleChangeCompanyName} />
                                        <br />
                                        <div className="bankinfoerror12">{companyNameError}</div>
                                    </div>
                                </div>
                                <div class="CompanyDivCardBottomCss">
                                    <div class="CompanyInputDivCss">
                                        <small id="CompanyUploadName">Upload CIPC Statement</small>
                                        <div class="show01">
                                            <small class="pt-1" id="bsmall1">(Not older then 3 months)</small>
                                        </div>
                                        <div class="show002">
                                            <small class="pb-1" id="bsmall1">(Not older than 3 months)</small>
                                        </div>
                                        <div>
                                            {uploadFileDisableCIPC &&
                                                <UploadFile uploaddivid="uploadCIPC" idupload="upload"
                                                    name="fileupload"
                                                    fileType="jpeg, jpg, png, pdf"
                                                    setUploadConfirm={uploadFileFun}
                                                    upload_link="cipcUpload" uploadicon="cipcIcon"
                                                    setFileLink={setUploadLinkCIPC}
                                                    removeLink={removeCIPCUploadedLink}
                                                    setLoader={setLoaderCIPC}
                                                    pdfFileName={fileNameCIPC}
                                                    isUploadDisabled={uploadFileDisableCIPC}
                                                    staticFileName={'CIPC_Statement.'}
                                                    readOnly={clickSave || (phone && !clickEdit)}
                                                />
                                            }
                                            {!uploadFileDisableCIPC &&
                                                <UploadFile uploaddivid="uploadCIPC" idupload="upload"
                                                    name="fileupload"
                                                    fileType="jpeg, jpg, png, pdf"
                                                    setUploadConfirm={uploadFileFun}
                                                    upload_link="cipcUpload" uploadicon="cipcIcon"
                                                    setFileLink={setUploadLinkCIPC}
                                                    removeLink={removeCIPCUploadedLink}
                                                    setLoader={setLoaderCIPC}
                                                    pdfFileName={fileNameCIPC}
                                                    isUploadDisabled={uploadFileDisableCIPC}
                                                    staticFileName={'CIPC_Statement.'}
                                                    readOnly={clickSave || (phone && !clickEdit)}
                                                />
                                            }
                                        </div>
                                        <div className="Companyerror1">{fileUploadError}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="bankbank1">
                                <small id="CompanyCardHaeding">VAT Information</small>
                            </div>
                            <div class="CompanyOuterCardCss" >
                                <div class="CompanyDivCardCss" id={isCheckVAT && "MakeVatInfoDivPointerNone"}>
                                    <div class="CompanyInputDivCss">
                                        <small id="name">VAT Registration Number</small>
                                        <br />
                                        {clickSave || (phone && !clickEdit) ?
                                            <small class="CompanyVATRegistrationNo">{vatRegNum}</small>
                                            :
                                            <>
                                                <Input
                                                    class="input"
                                                    type="text"
                                                    id="vatRegNum"
                                                    name="vatRegNum"
                                                    autoComplete="off"
                                                    value={vatRegNum}
                                                    readOnly={clickSave || (phone && !clickEdit)}
                                                    onChange={handleChangeVATRegNum} />
                                                <div className="bankinfoerror12">{vatRegNumError}</div>
                                            </>
                                        }
                                    </div>
                                    <div class="CompanyInputDivCss">
                                        <small id="name">Upload VAT Registration Certificate</small>
                                        <br />
                                        {uploadFileDisableVAT &&
                                            <UploadFile uploaddivid="uploadVAT" idupload="upload1" name="fileupload2" setUploadConfirm={uploadFileFunVAT}
                                                upload_link="vatUpload"
                                                fileType="jpeg, jpg, png, pdf"
                                                uploadicon="vatUploadIcon"
                                                vatFile="vatFile"
                                                setFileLink={setUploadLinkVAT}
                                                removeLink={removeVATUploadedLink}
                                                readOnly={clickSave || (phone && !clickEdit)}
                                                setLoader={setLoaderVAT}
                                                vatUploadType="vatUploadType"
                                                vatUploadTypeName="vatUploadTypeName"
                                                vatUploadSize="vatUploadSize"
                                                vatUploadSizeName="vatUploadSizeName"
                                                pdfFileName={fileNameVAT}
                                                isUploadDisabled={uploadFileDisableVAT}
                                                staticFileName={'VAT_Certificate.'}
                                            />
                                        }
                                        {!uploadFileDisableVAT &&
                                            <UploadFile uploaddivid="uploadVAT" idupload="upload1" name="fileupload2" setUploadConfirm={uploadFileFunVAT}
                                                upload_link="vatUpload"
                                                fileType="jpeg, jpg, png, pdf"
                                                uploadicon="vatUploadIcon"
                                                vatFile="vatFile"
                                                setFileLink={setUploadLinkVAT}
                                                removeLink={removeVATUploadedLink}
                                                readOnly={clickSave || (phone && !clickEdit)}
                                                setLoader={setLoaderVAT}
                                                vatUploadType="vatUploadType"
                                                vatUploadTypeName="vatUploadTypeName"
                                                vatUploadSize="vatUploadSize"
                                                vatUploadSizeName="vatUploadSizeName"
                                                pdfFileName={fileNameVAT}
                                                isUploadDisabled={uploadFileDisableVAT}
                                                staticFileName={'VAT_Certificate.'}
                                            />
                                        }
                                        <div className="Companyerror1">{fileUpload1Error}</div>
                                    </div>
                                </div>
                                {isCheckVAT &&
                                    <div class="CompanyVATChackDiv">
                                        <small id="terms" onClick={clickCheckbox ? null : toggleCheckVAT}>
                                            {isCheckVAT ?
                                                <img src={checked} id="checkicon" alt="" loading="lazy" /> :
                                                <img src={check} id="checkicon" alt="" loading="lazy" />}
                                            <small class="pl-2" id="bterms2">I declare that I am not registered for VAT
                                </small>
                                        </small>
                                    </div>
                                }
                                {!isCheckVAT &&
                                    <div class="CompanyVATChackDiv">
                                        <small id="terms" onClick={clickCheckbox ? null : toggleCheckVAT}>
                                            {isCheckVAT ?
                                                <img src={checked} id="checkicon" alt="" loading="lazy" /> :
                                                <img src={check} id="checkicon" alt="" loading="lazy" />}
                                            <small class="pl-2" id="bterms2">I declare that I am not registered for VAT
                                </small>
                                        </small>
                                    </div>
                                }
                            </div>
                            <div class="bankbank1">
                                <small id="CompanyCardHaeding">Physical Address</small>
                            </div>
                            <div class="CompanyOuterCardCss">
                                <div class="CompanyDivCardCss">
                                    <div class="CompanyInputDivCss">
                                        <small id="name">Address Line 1</small>
                                        <br />
                                        <Input
                                            class="input"
                                            type="text"
                                            id="addressL1"
                                            name="addressL1"
                                            autoComplete="off"
                                            value={addressL1}
                                            readOnly={clickSave || (phone && !clickEdit)}
                                            onChange={handleChangeAddressL1} />
                                        <div className="bankinfoerror12">{addressL1Error}</div>
                                    </div>
                                    <div class="CompanyInputDivCss">
                                        <small id="name">Address Line 2 (Optional)</small>
                                        <br />
                                        <Input
                                            class="input"
                                            type="text"
                                            id="addressL2"
                                            name="addressL2"
                                            autoComplete="off"
                                            value={addressL2}
                                            readOnly={clickSave || (phone && !clickEdit)}
                                            onChange={handleChangeAddressL2} />
                                    </div>
                                </div>
                                <div class="CompanyDivCardBottomCss">
                                    <div class="CompanyInputDivCss">
                                        <small id="name">City</small>
                                        <br />
                                        <Input
                                            class="input"
                                            type="text"
                                            id="city"
                                            name="city"
                                            autoComplete="off"
                                            value={city}
                                            readOnly={clickSave || (phone && !clickEdit)}
                                            onChange={handleChangeCity} />
                                        <div className="bankinfoerror12">{cityError}</div>
                                    </div>
                                    <div class="CompanyInputDivCss">
                                        <small id="name">Province</small>
                                        <br />
                                        <Input
                                            class="input"
                                            type="text"
                                            id="province"
                                            name="province"
                                            autoComplete="off"
                                            value={province}
                                            readOnly={clickSave || (phone && !clickEdit)}
                                            onChange={handleChangeProvince} />
                                        <div className="bankinfoerror12">{provinceError}</div>
                                    </div>
                                </div>
                                <div class="CompanyDivCardBottomCss">
                                    <div class="CompanyInputDivCss">
                                        <small id="name">Country</small>
                                        <br />
                                        <div className="pass-wrapper" id="companyCountryInputDiv" >
                                            <Input
                                                class="input"
                                                readOnly
                                                class="input"
                                                type="text"
                                                id="country"
                                                name="country"
                                                autoComplete="off"
                                                value={country}
                                                placeholder="Select Country"
                                                onChange={handleChangeCountry}
                                            />
                                            <div className="bankinfoerror12">{countryError}</div>
                                        </div>
                                    </div>
                                    <div class="CompanyInputDivCss">
                                        <small id="name">Postal Code</small>
                                        <br />
                                        <Input
                                            class="input"
                                            type="text"
                                            id="postalCode"
                                            name="postalCode"
                                            autoComplete="off"
                                            value={postalCode}
                                            readOnly={clickSave || (phone && !clickEdit)}
                                            onChange={handleChangePostalCode} />
                                        <div className="bankinfoerror12">{postalCodeError}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="bankbank1">
                                <small id="CompanyCardHaeding">Postal Address</small>
                            </div>
                            <div class="bmidcheck1">
                                <small id="terms" onClick={clickCheckbox ? null : () => { toggleCheckPostalAddress(); copyAddress() }}>
                                    {postalAddressCheck ?
                                        <img class="" src={checked} id="checkicon" alt="" loading="lazy" /> :
                                        <img class="" src={check} id="checkicon" alt="" loading="lazy" />}
                                    <small class="pl-1" id="terms03">Postal address is same as Physical address
                        </small>
                                </small>
                            </div>
                            <div class="CompanyOuterCardCss" id={(postalAddressCheck || clickSave || (phone && !clickEdit)) && "MakePostalAddCardPointerNone"}>
                                <div class="CompanyDivCardCss">
                                    <div class="CompanyInputDivCss">
                                        <small id="name">Address Line 1</small>
                                        <br />
                                        <Input
                                            class="input"
                                            type="text"
                                            id="postalAddressL1"
                                            name="postalAddressL1"
                                            autoComplete="off"
                                            value={postalAddressL1}
                                            onChange={handleChangePostalAddressL1}
                                            readOnly={postalAddressCheck || clickSave || (phone && !clickEdit)}
                                        />
                                        <div className="bankinfoerror12">{postalAddressL1Error}</div>
                                    </div>
                                    <div class="CompanyInputDivCss">
                                        <small id="name">Address Line 2 (Optional)</small>
                                        <br />
                                        <Input
                                            class="input"
                                            type="text"
                                            id="postalAddressL2"
                                            name="postalAddressL2"
                                            autoComplete="off"
                                            value={postalAddressL2}
                                            readOnly={postalAddressCheck || clickSave || (phone && !clickEdit)}
                                            onChange={handleChangePostalAddressL2} />
                                    </div>
                                </div>
                                <div class="CompanyDivCardBottomCss">
                                    <div class="CompanyInputDivCss">
                                        <small id="name">City</small>
                                        <br />
                                        <Input
                                            class="input"
                                            type="text"
                                            id="postalCity"
                                            name="postalCity"
                                            autoComplete="off"
                                            value={postalCity}
                                            readOnly={postalAddressCheck || clickSave || (phone && !clickEdit)}
                                            onChange={handleChangePostalCity} />
                                        <div className="bankinfoerror12">{postalCityError}</div>
                                    </div>
                                    <div class="CompanyInputDivCss">
                                        <small id="name">Province</small>
                                        <br />
                                        <Input
                                            class="input"
                                            type="text"
                                            id="postalProvince"
                                            name="postalProvince"
                                            autoComplete="off"
                                            value={postalProvince}
                                            readOnly={postalAddressCheck || clickSave || (phone && !clickEdit)}
                                            onChange={handleChangePostalProvince} />
                                        <div className="bankinfoerror12">{postalProvinceError}</div>
                                    </div>
                                </div>
                                <div class="CompanyDivCardBottomCss">
                                    <div class="CompanyInputDivCss">
                                        <small id="name">Country</small>
                                        <div className="pass-wrapper" id="companyCountryInputDiv" >
                                            <Input
                                                class="input"
                                                readOnly
                                                class="input"
                                                type="text"
                                                autoComplete="off"
                                                placeholder="Select Country"
                                                id="postalCountry"
                                                name="postalCountry"
                                                value={postalCountry}
                                                onChange={handleChangePostalCountry}
                                            />
                                            <div className="bankinfoerror12">{postalCountryError}</div>
                                        </div>
                                    </div>
                                    <div class="CompanyInputDivCss">
                                        <small id="name">Postal Code</small>
                                        <br />
                                        <Input
                                            class="input"
                                            type="text"
                                            id="postalPostalCode"
                                            name="postalPostalCode"
                                            autoComplete="off"
                                            value={postalPostalCode}
                                            readOnly={postalAddressCheck || clickSave || (phone && !clickEdit)}
                                            onChange={handleChangePostalPostalCode} />
                                        <div className="bankinfoerror12">{postalPostalCodeError}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="CompanyPageBtn">
                            <Button id="bbttncountine" class="companybbttn1 " onClick={onSubmit}>Continue</Button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            {hasOpenterms ? <TermsConditionModal onClick={onClosetermsModal} /> : null}
            <SubmitModal hasOpen={hasOpen} onCloseModal={onCloseModal} />
            {/* pending state pop up modal */}
            {hasOpenPending ? <AddProfileModal hasOpen={hasOpenPending} onCloseModal={onClosePending} >
                <div>
                    <div class="successtext1outercreatepreadvise">
                        <small class="addprofilemodalsmall">{
                            profileApproved.includes(profileTypeAndStatus) ?
                                Message.profileManagement.approvedProfile
                                :
                                Message.profileManagement.pendingProfile
                        }</small>
                    </div>
                </div>
            </AddProfileModal> : null}
        </div>
    );
}
export default CompanyInfo;
